import { Close } from '@material-ui/icons';
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useContext, useState } from 'react';
import { CustomContext } from '../page';
import { CircularProgress } from '@material-ui/core';
import { adminUpdateBooking } from '../../../services/apiService';
import { toast } from 'react-toastify';
import moment from 'moment';

export default function UpdateSessionDateTime({ booking, refreshData }) {
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { setSelectedAction } = useContext(CustomContext);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      const startTime = selectedDateTime.toISOString();
      const endTime = moment(selectedDateTime).add(1, 'hour').toISOString();
      const payload = {
        id: booking.id,
        startTime,
        endTime,
      };
      await adminUpdateBooking(payload);
      setSelectedAction(null);
      toast.success('Updated session');
      refreshData();
    } catch (err) {
      console.error(err);
      toast.error('Failed to update session');
    }
  };

  return (
    <div className='fixed inset-0 bg-black bg-opacity-80 flex'>
      <div className='m-auto w-full max-w-2xl bg-white rounded p-5 relative'>
        <h6 className='text-lg opacity-80'>Edit session date:</h6>

        <button
          onClick={() => setSelectedAction(null)}
          className='absolute top-4 right-4 opacity-60'
        >
          <Close />
        </button>

        <div className='flex mt-4'>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDateTimePicker
              onChange={setSelectedDateTime}
              value={selectedDateTime || new Date()}
              format='dd-MMM-yy hh:mm'
              inputVariant='outlined'
              disablePast
            />
          </MuiPickersUtilsProvider>
        </div>

        <button
          onClick={handleSubmit}
          disabled={isLoading}
          className='bg-blue-c1 text-white rounded w-48 py-1 mt-6 ml-auto flex justify-center'
        >
          {isLoading ? (
            <CircularProgress color='inherit' size='1.5rem' />
          ) : (
            <span>Update</span>
          )}
        </button>
      </div>
    </div>
  );
}
